import React from 'react'
import { CreateBillRateFlowProvider } from './context/CreateBillRateFlowProvider'
import { CreateBillRateFlowMain } from './components/CreateBillRateFlowMain'

export const CreateBillRateFlow = () => {
  return (
    <CreateBillRateFlowProvider>
      <CreateBillRateFlowMain />
    </CreateBillRateFlowProvider>
  )
}
